import { Protocol } from '../Protocol';
// MOCK假資料
export class testI18nProtocol {
  public static readonly I18n: string = `${Protocol.YATUNG_API_ROOT}/yatung/mock/i18n`;
}
